//toggle
(function() {
  if (window.jQuery && !window.jQuery._suzParseJsonGuardInstalled) {
    var _originalParseJSON = window.jQuery.parseJSON;
    window.jQuery.parseJSON = function(data) {
      if (data == null) {
        return { products: [] };
      }
      if (typeof data === 'string' && data.trim() === '') {
        return { products: [] };
      }
      try {
        return _originalParseJSON.call(this, data);
      } catch (e) {
        return { products: [] };
      }
    };
    window.jQuery._suzParseJsonGuardInstalled = true;
  }

  function getCartItemCount() {
    if (window.CartJS && CartJS.cart && typeof CartJS.cart.item_count === 'number') {
      return CartJS.cart.item_count;
    }
    var countEl = document.querySelector('.head-right-link .item-count');
    if (countEl) {
      var parsed = parseInt((countEl.textContent || '').trim(), 10);
      if (!isNaN(parsed)) {
        return parsed;
      }
    }
    return 0;
  }

  function syncMiniCartBlocks() {
    var hasItems = getCartItemCount() > 0;
    var addProductBlocks = document.querySelectorAll('.mini-cart-block.add-product');
    var blankCartBlocks = document.querySelectorAll('.mini-cart-block.blank-cart-1');

    for (var i = 0; i < addProductBlocks.length; i++) {
      addProductBlocks[i].style.display = hasItems ? 'block' : 'none';
    }

    for (var j = 0; j < blankCartBlocks.length; j++) {
      blankCartBlocks[j].style.display = hasItems ? 'none' : 'block';
    }
  }

  function refreshMiniCartData() {
    if (window.CartJS && typeof CartJS.getCart === 'function') {
      CartJS.getCart();
    }

    if (window.jQuery) {
      window.jQuery.getJSON('/cart.js').done(function(cart) {
        window.jQuery(document).trigger('cart.requestComplete', [cart]);
        syncMiniCartBlocks();
        setTimeout(function() {
          var unresolvedBinding = document.querySelector('.mini-cart-slide.active [rv-each-item]');
          if (unresolvedBinding) {
            renderMiniCartFallback(cart);
          }
        }, 250);
      });
    }
  }

  function formatMoneyFromCents(cents) {
    var symbol = (window.theme && theme.moneyFormat) ? theme.moneyFormat.split('{')[0] : '£';
    var value = (parseInt(cents, 10) || 0) / 100;
    return '<span class="money">' + symbol + value.toFixed(2) + '</span>';
  }

  function buildMiniCartQtyHtml(line, quantity) {
    var qty = parseInt(quantity, 10) || 0;
    var minusQty = Math.max(0, qty - 1);
    return '<div class="quantity-selector">' +
      '<div class="quantity-selector-cart">' +
      '<a class="qtyBtn" href="#" data-cart-update="' + line + '" data-cart-quantity="' + minusQty + '" aria-label="Decrease quantity">-</a>' +
      '<span class="qtyBtn qty-display">' + qty + '</span>' +
      '<a class="qtyBtn" href="#" data-cart-update="' + line + '" data-cart-quantity="' + (qty + 1) + '" aria-label="Increase quantity">+</a>' +
      '</div></div>';
  }

  function updateMiniCartLineQuantity(line, quantity) {
    var lineNum = parseInt(line, 10);
    var qty = parseInt(quantity, 10);
    if (isNaN(lineNum) || lineNum < 1 || isNaN(qty) || qty < 0) return;

    if (window.CartJS && typeof CartJS.updateItem === 'function') {
      CartJS.updateItem(lineNum, qty);
    } else if (window.jQuery) {
      window.jQuery.post('/cart/change.js', { line: lineNum, quantity: qty }).always(function() {
        refreshMiniCartData();
      });
    }
  }

  function renderMiniCartFallback(cart) {
    if (!cart || !cart.items) return;
    var minicart = document.querySelector('.mini-cart-slide');
    if (!minicart) return;

    var scrollBlock = minicart.querySelector('.add-product .scroll-block');
    var totalSpan = minicart.querySelector('.mini-cart-bottom .total span');
    var countText = minicart.querySelector('.add-product p span[rv-text]');

    if (countText) {
      countText.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    }

    if (scrollBlock) {
      var html = '';
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        html += '<div class="cart-product-list d-block clearfix"><div class="cpl-row d-block clearfix">';
        html += '<div class="cart-product-img"><a href="' + (item.url || '#') + '" class="product-image-111"><img src="' + (item.image || '') + '" alt="' + (item.product_title || '') + '"></a></div>';
        html += '<div class="product-desc sz-product-desc-info"><h4><a href="' + (item.url || '#') + '">' + (item.product_title || '') + '</a></h4>';
        html += '<div class="price minicart-price d-block"><span class="discounted-price">' + formatMoneyFromCents(item.line_price) + '</span></div>';
        if (item.variant_options && item.variant_options.length) {
          html += '<ul>';
          for (var j = 0; j < item.variant_options.length; j++) {
            if (item.variant_options[j] && item.variant_options[j].indexOf('Default') === -1) {
              html += '<li><span class="size d-block">' + item.variant_options[j] + '</span></li>';
            }
          }
          html += '</ul>';
        }
        html += buildMiniCartQtyHtml(i + 1, item.quantity);
        html += '<a href="#" class="remove remove-link d-block sz-remove-cartitem" data-cart-remove="' + (i + 1) + '">Delete item</a>';
        html += '</div></div></div>';
      }
      scrollBlock.innerHTML = html;
    }

    if (totalSpan) {
      totalSpan.innerHTML = formatMoneyFromCents(cart.total_price);
    }
  }

  function openMiniCart() {
    var minicarts = document.querySelectorAll('.mini-cart-slide');
    var body = document.querySelector('body');
    var overlay = document.querySelector('.overlay');
    if (!minicarts.length || !body) return;

    function applyOpenClasses() {
      for (var i = 0; i < minicarts.length; i++) {
        minicarts[i].classList.add('active');
      }
      body.classList.add('drawer-open');
      if (overlay) {
        overlay.classList.add('active');
      }
    }

    applyOpenClasses();
    // Re-assert in case third-party scripts remove classes immediately.
    setTimeout(applyOpenClasses, 50);
    setTimeout(applyOpenClasses, 180);

    refreshMiniCartData();
    syncMiniCartBlocks();
    document.dispatchEvent(new CustomEvent('suz:minicart-open'));
  }

  window.SUZOpenMiniCart = function(e) {
    if (e) {
      if (e.preventDefault) e.preventDefault();
      if (e.stopPropagation) e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }
    openMiniCart();
    return false;
  };

  function closeMiniCart() {
    var minicarts = document.querySelectorAll('.mini-cart-slide');
    var body = document.querySelector('body');
    var overlay = document.querySelector('.overlay');
    if (!minicarts.length || !body) return;

    for (var i = 0; i < minicarts.length; i++) {
      minicarts[i].classList.remove('active');
    }
    body.classList.remove('drawer-open');
    if (overlay) {
      overlay.classList.remove('active');
    }
  }

  function onBagActivate(e) {
    if (window.jQuery) {
      // Extra safety: disable legacy delegated bag handlers before opening.
      window.jQuery(document).off('click', '.head-right-link .bag');
      window.jQuery(document).off('click', '.head-right-link .bag-link');
    }
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) {
      e.stopImmediatePropagation();
    }
    window.SUZOpenMiniCart(e);
  }

  function onCloseActivate(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) {
      e.stopImmediatePropagation();
    }
    closeMiniCart();
  }

  function bindMiniCartTriggers() {
    // Remove legacy delegated handler from theme script that parses mini-cart feed
    // with $.parseJSON and crashes on empty/invalid payloads.
    if (window.jQuery) {
      window.jQuery(document).off('click', '.head-right-link .bag');
    }

    function resolveBagTarget(target) {
      if (!target || !target.closest) return null;
      var bagLink = target.closest('.head-right-link .bag-link, .head-right-link .bag-item a[aria-label="Open shopping bag"], .head-right-link .icon-cart');
      if (bagLink) return bagLink;
      return null;
    }

    function handleMiniCartTrigger(e) {
      var bag = resolveBagTarget(e.target);
      var close = e.target.closest('.mini-cart-slide .close');
      var qtyBtn = e.target.closest('.mini-cart-slide .quantity-selector-cart a.qtyBtn');
      var remove = e.target.closest('.mini-cart-slide .sz-remove-cartitem');
      if (qtyBtn) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) {
          e.stopImmediatePropagation();
        }

        var qtyLine = parseInt(
          qtyBtn.getAttribute('data-cart-update') || qtyBtn.getAttribute('rv-data-cart-update'),
          10
        );
        var newQty = parseInt(
          qtyBtn.getAttribute('data-cart-quantity') || qtyBtn.getAttribute('rv-data-cart-quantity'),
          10
        );
        updateMiniCartLineQuantity(qtyLine, newQty);
        return;
      }
      if (remove) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) {
          e.stopImmediatePropagation();
        }

        var line = parseInt(remove.getAttribute('data-cart-remove'), 10);
        if (!isNaN(line) && line > 0) {
          if (window.CartJS && typeof CartJS.updateItem === 'function') {
            CartJS.updateItem(line, 0);
          } else if (window.jQuery) {
            window.jQuery.post('/cart/change.js', { line: line, quantity: 0 }).always(function() {
              refreshMiniCartData();
            });
          }
        }
        return;
      }
      if (bag) {
        onBagActivate(e);
      } else if (close) {
        onCloseActivate(e);
      }
    }

    function bindDirectBagListeners() {
      var bagLinks = document.querySelectorAll('.head-right-link .bag-link');
      for (var i = 0; i < bagLinks.length; i++) {
        bagLinks[i].addEventListener('click', onBagActivate, true);
        bagLinks[i].addEventListener('touchstart', onBagActivate, { capture: true, passive: false });
      }
    }

    // Capture phase keeps this ahead of bubbling handlers from apps/plugins.
    // Bind on window as well so we run before document-level capture interceptors.
    window.addEventListener('pointerdown', handleMiniCartTrigger, { capture: true, passive: false });
    window.addEventListener('touchstart', handleMiniCartTrigger, { capture: true, passive: false });
    window.addEventListener('click', handleMiniCartTrigger, true);
    document.addEventListener('pointerdown', handleMiniCartTrigger, { capture: true, passive: false });
    document.addEventListener('click', handleMiniCartTrigger, true);
    document.addEventListener('touchstart', handleMiniCartTrigger, { capture: true, passive: false });
    bindDirectBagListeners();
    // Some collection apps re-render header fragments after initial load.
    setTimeout(bindDirectBagListeners, 800);

    if (window.jQuery) {
      window.jQuery(document).on('cart.ready cart.requestComplete', function() {
        syncMiniCartBlocks();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindMiniCartTriggers);
  } else {
    bindMiniCartTriggers();
  }
})();

//GA notify 
function custom_ga_track_event(track_event,track_label){
  if (typeof ga != "undefined") {
    ga('send', 'event', 'Shopify Theme', track_event, track_label);
  }
  console.log('EVENT TRACKED:'+track_event+' = '+track_label);
}
$(document).ready(function() {
  $("#book_consultation").click(function(){
    custom_ga_track_event('product','book consultation');
  });
  $("a.consult").click(function(){
    custom_ga_track_event('boutique','book consultation');
  });
});

//headerfixed
$(document).ready(function() {

  if($('.product-recommendations').length > 0) {
    setTimeout(function() {
        $(".product-carousel").removeClass("hide");
        $(".js-title").removeClass("hide");
        $('.product-carousel').slick();
        //fixed sometime product not showing
        var fired = false;
        window.addEventListener("scroll", function(){
          if ($(window).scrollTop() >= 600 && fired === false && $(".product-carousel").hasClass("hide") ) {
          $(".product-carousel").removeClass("hide");
          $(".js-title").removeClass("hide");
          $('.product-carousel').slick();
            fired = true;
          }
        }, true)          
    }, 2000);
  }

  if($('.ymal-carousel').length > 0) {
    var ymal_count = $(".js-ymal-container").attr("js-ymal-count");
    if(ymal_count > 1) {
      if(ymal_count > 2)  $('.ymal-carousel').slick();
/*      enquire.register("screen and (max-width:767px)", {
          match : function() {
            if($('.ymal-carousel').hasClass("slick-initialized")){}
           // else { $('.ymal-carousel').slick(); }
          },
          unmatch : function() {          
             if(ymal_count < 3) {
              // $('.ymal-carousel').slick('unslick');
             }
          },

      });*/
    }
  }

   $(".toshi-btn").click(function(){  
      $('.css-hmngz').html('TOSHI On-demand delivery');
   });
  $(".announcement-bar").removeClass("hide");
  //$('.header').scrollToFixed();
  /*
  $('.collection-header .filter-row').scrollToFixed({
    marginTop: $('.header').outerHeight()
  });
  */

addMiniCartComplement();
function addMiniCartComplement(){

     
          var url = 'https://www.suzannah.com/en-in/pages/mini-cart-feed';
          $.ajax({  
            url: url,
            type: "get"
          })
          .done(function (data){
            $('.mini-complement-product').append(data.products);
          })
          .fail(function (data) {
            // Request failed
            console.log(data);
          });       

}


$(document).on('click, touchstart', '.currency .submenu li a', function(e){
  e.preventDefault();
  var currency_val = $(this).parent().data('value');console.log(currency_val);
  $('select.currency-picker').val(currency_val).trigger('change');
  $("body").removeClass("mmactive");
  $("#sm_menu_ham").removeClass("open");
  $(".sm_menu_outer").removeClass("active");
});

  $("span.close-bar-btn").click(function(){
    $(".announcement-bar").addClass("hide");
    sessionStorage.setItem("closeBar", "true");
    $("body").removeClass("notify-bar");
  });

  if(sessionStorage.getItem("closeBar")){
    $(".announcement-bar").addClass("hide");
  }else{
    $(".announcement-bar").removeClass("hide");
    $("body").addClass("notify-bar");
  }

  $("p.newsearch").click(function(){
    $(".search-block.clearfix").addClass("active");
  });

  $(window).scroll(function() {
    var st = $(window).scrollTop();
    if(st > $(".announcement-bar").height()){
      $("body").removeClass("notify-bar");
    }else{
      $("body").addClass("notify-bar");
    }
  });
  
  //  discount js - [disabled] code should no longer be needed as TAX is now included inn prices.
  
  /*
   $(document).on("click","#dcodeSubmit",function() {
     //discountUpdate("500");
     $('body').addClass('hide-dcode');
     $('.dcode-fix-message').show();
     setTimeout(function(){ discountReload() },500);
   });
  $(document).on("click","#removeDiscount",function() {
   var original_price = $(".total .js-total-price span").data("currency-gbp");
   $(".total .js-total-price span").text(original_price);
  }); 
  
  if($(".template-cart").length > 0) {
      discountUpdate("100");
      $(document).on('cart.requestComplete', function(event, cart) {
        if($("#removeDiscount").length > 0) {
          $(".dcodeTable").css("display", "none");
          location.reload();
        }
      });

  }

  function discountReload(){
  	if($(".dcode-discount-label").length > 0) {
      location.reload();
    }else{
      console.log('waiting for code to apply');
      setTimeout(function(){ discountReload() },500);
    }
  }
  
  function discountUpdate(timer) {
    var myVar = setInterval(myTimer, timer);
    
    
    function myTimer() {
      
      if($(".dcode-discount-value").length > 0) {
        var discount = $(".dcode-discount-value").text(); 
        //console.log('found discount: '+discount);
        
        if ($(".dcode-discount-values").length == 0) {
         
          $(".dcode-discount-row .money").append("<span class='dcode-discount-values'>" + parseFloat(discount*1.2).toFixed(2) +"</span>");
        }   
      if($(".money .dcode-total-value").length > 0) {
        var withDiscount = $(".money .dcode-total-value").text(); 
        //console.log('found withDiscount: '+withDiscount);
        
        if ($(".dcode-total-values").length == 0) {
           $(".dcode-total-row .money").append("<span class='money dcode-total-values'>" + parseFloat(withDiscount*1.2).toFixed(2) +"</span>");
           var currency = $(".dcode-total-currency").html();
          
           //console.log('found currency: '+currency);
          
           $(".total .js-total-price span").text(currency + parseFloat(withDiscount*1.2).toFixed(2));
          //clearInterval(myVar);
           setTimeout(function(){  clearInterval(myVar); }, 10000);
        }
      }     
      
     }
      else {
       setTimeout(function(){  clearInterval(myVar); }, 10000);
      }
    }   
    
  }
 */
  // END discount js
});

// Artist profile: lightbox carousel scoped to each section gallery
(function() {
  var activeLightbox = null;

  function closest(el, selector) {
    if (!el || !el.closest) return null;
    return el.closest(selector);
  }

  function getGallerySlides(section, activeAnchor) {
    var anchors = section.querySelectorAll('a[data-artist-lightbox]');
    var slides = [];
    var seen = {};
    var activeHref = activeAnchor.getAttribute('href');
    var index = 0;

    for (var i = 0; i < anchors.length; i++) {
      var href = anchors[i].getAttribute('href');
      if (!href || seen[href]) continue;
      seen[href] = true;

      var thumb = anchors[i].querySelector('img');
      slides.push({
        src: href,
        alt: thumb && thumb.alt ? thumb.alt : ''
      });
    }

    if (activeHref) {
      for (var j = 0; j < slides.length; j++) {
        if (slides[j].src === activeHref) {
          index = j;
          break;
        }
      }
    }

    return { slides: slides, index: index };
  }

  function updateLightboxNav(state) {
    var multi = state.slides.length > 1;
    var prev = state.lightbox.querySelector('.artist-lightbox__nav--prev');
    var next = state.lightbox.querySelector('.artist-lightbox__nav--next');
    var counter = state.lightbox.querySelector('.artist-lightbox__counter');

    if (prev) prev.hidden = !multi;
    if (next) next.hidden = !multi;
    if (counter) {
      if (multi) {
        counter.hidden = false;
        counter.textContent = (state.index + 1) + ' / ' + state.slides.length;
      } else {
        counter.hidden = true;
        counter.textContent = '';
      }
    }
  }

  function showLightboxSlide(state, index) {
    if (!state || !state.slides.length) return;

    var total = state.slides.length;
    state.index = ((index % total) + total) % total;
    var slide = state.slides[state.index];

    state.img.src = slide.src;
    state.img.alt = slide.alt;
    updateLightboxNav(state);
  }

  function closeArtistLightbox(lightbox) {
    if (!lightbox) return;

    lightbox.setAttribute('hidden', '');
    lightbox.setAttribute('aria-hidden', 'true');

    if (activeLightbox && activeLightbox.lightbox === lightbox) {
      activeLightbox.img.removeAttribute('src');
      activeLightbox.img.removeAttribute('alt');
      activeLightbox = null;
    }

    if (!document.querySelector('[data-artist-lightbox-modal]:not([hidden])')) {
      document.body.classList.remove('artist-lightbox-open');
    }
  }

  function openArtistLightbox(anchor) {
    var section = closest(anchor, '.artist-profile');
    if (!section) return;

    var lightbox = section.querySelector('[data-artist-lightbox-modal]');
    var img = lightbox && lightbox.querySelector('.artist-lightbox__img');
    if (!lightbox || !img) return;

    var gallery = getGallerySlides(section, anchor);
    if (!gallery.slides.length) return;

    activeLightbox = {
      lightbox: lightbox,
      img: img,
      slides: gallery.slides,
      index: gallery.index
    };

    showLightboxSlide(activeLightbox, gallery.index);
    lightbox.removeAttribute('hidden');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('artist-lightbox-open');
  }

  function bindArtistLightbox() {
    document.addEventListener('click', function(e) {
      var a = closest(e.target, 'a[data-artist-lightbox]');
      if (a) {
        e.preventDefault();
        openArtistLightbox(a);
        return;
      }

      var prev = closest(e.target, '.artist-lightbox__nav--prev');
      if (prev && activeLightbox) {
        e.preventDefault();
        showLightboxSlide(activeLightbox, activeLightbox.index - 1);
        return;
      }

      var next = closest(e.target, '.artist-lightbox__nav--next');
      if (next && activeLightbox) {
        e.preventDefault();
        showLightboxSlide(activeLightbox, activeLightbox.index + 1);
        return;
      }

      var closeTarget = closest(e.target, '.artist-lightbox__close, .artist-lightbox__backdrop');
      if (!closeTarget) return;
      e.preventDefault();
      closeArtistLightbox(closest(closeTarget, '[data-artist-lightbox-modal]'));
    });

    document.addEventListener('keydown', function(e) {
      if (!activeLightbox) return;

      if (e.key === 'Escape') {
        closeArtistLightbox(activeLightbox.lightbox);
        return;
      }

      if (activeLightbox.slides.length < 2) return;

      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        showLightboxSlide(activeLightbox, activeLightbox.index - 1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        showLightboxSlide(activeLightbox, activeLightbox.index + 1);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindArtistLightbox);
  } else {
    bindArtistLightbox();
  }
})();
